import {useAtom} from "jotai";
import React, {useCallback, useEffect, useState} from "react";
import {ModalBody, ModalHeader} from "../modal/Modal";
import styled from "styled-components";
import {selKeywordUser} from "../../services/platform/ManageUserAxios";
import {modalController} from "../../store";
import {
  ColSpan4,
  RelativeDiv,
  RowSpan,
  SaveExcelButton,
  SearchButton
} from "../../assets/GlobalStyles";
import {accountCreateInvoice} from "../../pages/account_manage/entity";
import {decimalFormat, removeStr} from "../../common/StringUtils";
import {useForm} from "react-hook-form";
import {tokenResultAtom} from "../../pages/login/entity";
import {AccountButton} from "../../pages/account_manage/styles";

function ModalHistoryAdd(props) {
  const [tokenResultInfo] = useAtom(tokenResultAtom)
  const [, setModal] = useAtom(modalController)
  const {selectedItem, setValidation} = props;
  const [createInvoice, setCreateInvoice] = useState(accountCreateInvoice)
  const {register, setValue, setError, formState:{errors} } = useForm()
  useEffect(() => {
    if (selectedItem.username !== undefined) {
      setError('requestAmountValue', '');

      setCreateInvoice(prev => ({
        ...prev,
        username: selectedItem.username,
        managerName: selectedItem.staffName,
        requesterId: tokenResultInfo.id,
      }));

      return;
    }

    setCreateInvoice(prev => ({
      ...prev,
      username: '',
      requesterId: '',
      invoiceStatus: 'REVENUE_INCREASE',
    }));
  }, [selectedItem.username, tokenResultInfo.id, setError]);

  const invoiceParams = () => {
    if(selectedItem.username !== undefined) {
      if(createInvoice.requestAmount >= 100000) {
        props.onSubmit(createInvoice)
        setModal({
          isShow: false,
          modalComponent: null
        })
      } else {
        setError('requestAmountValue', {type: 'required', message:'정산 신청금은 최소 10만원 이상 설정 가능합니다.'})
      }
    } else setValidation('매체를 선택해주세요.')
  }

  const revenueType = (value) => {
    setCreateInvoice({
      ...createInvoice,
      invoiceStatus : value
    })
  }

  const etcText = (value)=> {
    setCreateInvoice({
      ...createInvoice,
      etc : value
    })
  }

  const handleChange = (value) => {
    let num = removeStr(value)
    let numberNum = Number(num)
    if(selectedItem.username !== undefined){
      setCreateInvoice({
        ...createInvoice,
        requestAmount : numberNum,
      })
      setValue('requestAmountValue', numberNum)
      setError('requestAmountValue', '')
    } else {
      setError('requestAmountValue', {type: 'required', message:'매체를 먼저 선택해주세요.'})
    }
  }
  return (
      <HistoryAdd>
        <p>이력 추가</p>
        <div className={'border-box'}>
          <RowSpan style={{marginTop: 0}}>
            <ColSpan4 style={{paddingLeft: 0}}>
              <span>신청 금액 설정</span>
              <RelativeDiv style={{display: 'flex'}}>
                <input type={'radio'} id={'increment'} name={'proposeState'} checked={createInvoice.invoiceStatus.includes('REVENUE_INCREASE') ? true : false} onChange={() => revenueType('REVENUE_INCREASE')}/>
                <label htmlFor={'increment'}>증가</label>
                <input type={'radio'} id={'decrement'} name={'proposeState'} checked={createInvoice.invoiceStatus.includes('REVENUE_DECREASE') ? true : false} onChange={() => revenueType('REVENUE_DECREASE')}/>
                <label htmlFor={'decrement'}>감소</label>
              </RelativeDiv>
            </ColSpan4>
          </RowSpan>
          <RowSpan>
            <div className={'inputCon'}>
              <span>금액 입력</span>
              <div className={'won'}>
                <input type={'text'} value={decimalFormat(createInvoice.requestAmount)}
                       {...register("requestAmountValue", {
                         required: "정산 금액을 입력해주세요,",
                         pattern:{
                           value: /^[0-9,]+$/,
                           message: "숫자만 입력 가능합니다."
                         },
                         onChange:(e) => handleChange(e.target.value)
                       })}
                />
              </div>
            </div>
          </RowSpan>
          {errors.requestAmountValue && <p style={{color: '#f55a5a', fontSize: 12, paddingLeft: 88}}>{errors.requestAmountValue.message}</p>}
          <RowSpan style={{marginTop: 15}}>
            <ColSpan4 style={{paddingLeft: 0}}>
              <span>비고</span>
              <div>
                <textarea placeholder={'내용을 입력해주세요.'}
                          value={createInvoice.etc}
                          onChange={ e => etcText(e.target.value)}
                />
              </div>
            </ColSpan4>
          </RowSpan>
        </div>
        <MediaSelectedButton onClick={invoiceParams}>이력 추가</MediaSelectedButton>
      </HistoryAdd>
  )
}

export function SearchUser(props) {
  const {title, onSubmit, btnStyle, historyAdd} = props;
  const [, setModal] = useAtom(modalController)
  useEffect(()=>{
    return () => {
      setModal({isShow:false});
    }
  },[setModal])
  const handleModalComponent = () => {
    setModal({
      isShow: true,
      width: historyAdd !== undefined ? 700 : 800,
      blur: historyAdd === undefined,
      modalComponent: () => {
        return (
          <SearchModal onSubmit={onSubmit} historyAdd={historyAdd}/>
        )
      }
    })
  }

switch (btnStyle){
  case 'mediaCreate' : return <MediaCreateSearchButton type="button" onClick={handleModalComponent}>{title}</MediaCreateSearchButton>;
  case 'SearchUser' : return <SearchButton onClick={handleModalComponent}>{title}</SearchButton>;
  case 'AccountButton' : return <AccountButton style={{backgroundColor: 'var(--color-surface)'}} onClick={handleModalComponent}>{title}</AccountButton>;
  case 'SwitchUserButton' : return <SwitchUserButton onClick={handleModalComponent}>{title}</SwitchUserButton>;
  case 'historyAddButton' : return <SaveExcelButton className={'listUp'} onClick={handleModalComponent}>이력 추가</SaveExcelButton>;
  default : return <Button type={'button'} onClick={handleModalComponent}>{title}</Button>;
  }
}


function SearchModal (props) {
  const [, setModal] = useAtom(modalController)
  const [mediaSearchInfo, setMediaSearchInfo] = useState(null)
  const [selectedItem, setSelectedItem] = useState({})
  const [searchKeyword, setSearchKeyword] = useState('')
  const [validation, setValidation] = useState('')

  const handleSelect = (item) => {
    setSelectedItem(item)
    setValidation('')
  }

  const handleSubmit = () => {
    if (selectedItem.username !== undefined) {
      setModal({
        isShow: false,
        modalComponent: null
      })
      props.onSubmit(selectedItem)
      setValidation('')
    } else setValidation('매체를 선택해주세요.')
  }

  const handleCancel = () => {
    setModal({isShow: false, modalComponent: null})
  }

  const handleOnSearchKeyword = (e) => {
    setSearchKeyword(e.target.value)
  }
  const handleSearch = useCallback(() => {
    selKeywordUser(searchKeyword).then(response => {
      if (response !== null) {
        setMediaSearchInfo(response);
        response?.length !== 0
            ? setValidation('')
            : setValidation('검색된 매체가 존재하지 않습니다.');
      } else {
        setValidation('검색된 매체가 존재하지 않습니다.');
      }
    });

    setSelectedItem({});
  }, [searchKeyword]);

  useEffect(() => {
    handleSearch();
  }, [handleSearch]);

  return (
      <SearchModalShell>
        <ModalHeader title={"검색"} variant="search"/>
        <ModalBody>
          <SearchIntro>
            <div>
              <strong>매체 검색</strong>
              <p>매체명 또는 아이디로 지면을 등록할 매체를 검색합니다.</p>
            </div>
            <ResultCount>{mediaSearchInfo?.length ?? 0}건</ResultCount>
          </SearchIntro>
          <SearchCard>
          <MediaSearchColumn>
            <div>매체 검색</div>
            <div>
              <InputGroup>
                <input type={'text'}
                       placeholder={"매체명/아이디를 입력해주세요."}
                       autoFocus={true}
                       value={searchKeyword}
                       onChange={e => handleOnSearchKeyword(e)}
                       onKeyDown={event => (event.key === 'Enter') && handleSearch() }
                />
                <button type={'button'} onClick={handleSearch}>검색</button>
              </InputGroup>
            </div>
          </MediaSearchColumn>
          <MediaSearchResult>
            {mediaSearchInfo !== null && mediaSearchInfo.length !== 0 &&
                <div className="table-scroll">
                  <table>
                    <thead>
                    <tr>
                      <th aria-label="선택"/>
                      <th>매체명</th>
                      <th>아이디</th>
                      <th>담당자명</th>
                    </tr>
                    </thead>
                    <tbody>
                    {mediaSearchInfo.map((item, key) => {
                      return (
                          <tr key={key}
                              onClick={() => handleSelect(item)}
                              className={selectedItem.username === item.username ? "is-selected" : ""}>
                            <td><SelectionRadio $selected={selectedItem.username === item.username}/></td>
                            <td>{item.siteName}</td>
                            <td>{item.username}</td>
                            <td>{item.staffName}</td>
                          </tr>
                      )
                    })}
                    </tbody>
                  </table>
                </div>
            }
            {validation !== '' && <Validation>{validation}</Validation>}
          </MediaSearchResult>
          </SearchCard>
          {props.historyAdd !== undefined && <ModalHistoryAdd selectedItem={selectedItem} setValidation={setValidation} onSubmit={props.onSubmit}/>}
          {props.historyAdd === undefined &&
              <SearchModalActions>
                <CancelSearchButton type="button" onClick={handleCancel}>취소</CancelSearchButton>
                <MediaSelectedButton type="button" disabled={selectedItem.username === undefined} onClick={handleSubmit}>선택 완료</MediaSelectedButton>
              </SearchModalActions>
          }
        </ModalBody>
      </SearchModalShell>
  )
}

const SearchModalShell = styled.div`
  overflow: hidden;
  border-top: 3px solid var(--color-primary);
  border-radius: 10px;
`;

const SearchIntro = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 15px;

  strong {
    color: #303945;
    font-size: var(--font-size-15);
    font-weight: 800;
  }

  p {
    margin: 6px 0 0;
    color: #8b949f;
    font-size: var(--font-size-11);
  }
`;

const ResultCount = styled.span`
  display: inline-flex;
  height: 24px;
  align-items: center;
  padding: 0 9px;
  border: 1px solid var(--color-primary-border);
  border-radius: 999px;
  background: var(--color-primary-soft);
  color: var(--color-primary-strong);
  font-size: var(--font-size-11);
  font-weight: 750;
`;

const SearchCard = styled.div`
  overflow: hidden;
  border: 1px solid #e1e6eb;
  border-radius: 9px;
  background: #f7f9fc;
`;

const MediaSearchColumn = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 14px;
  padding: 18px;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #e5eaf0;
  border-radius: 0;
  background-color: #f7f9fc;

  & > div:first-child {
    min-width: 64px;
    color: #3e4955;
    font-size: var(--font-size-13);
    font-weight: 750;
  }

  & > div:last-child {
    width: 100%;
  }
`

const MediaCreateSearchButton = styled.button`
  display: inline-flex;
  min-width: 84px;
  height: 42px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border: 1px solid var(--color-primary);
  border-radius: 8px;
  background: var(--color-primary);
  box-shadow: 0 5px 14px rgba(59, 130, 246, .18);
  color: var(--color-surface);
  font-size: var(--font-size-13);
  font-weight: 750;
  cursor: pointer;

  &:hover {
    border-color: var(--color-primary-strong);
    background: var(--color-primary-strong);
  }

  &:focus-visible {
    outline: 3px solid rgba(59, 130, 246, .18);
    outline-offset: 2px;
  }
`;

const MediaSelectedButton = styled.button`
  display: inline-flex;
  margin: 0;
  width: 104px;
  height: 42px;
  border: 1px solid var(--color-primary);
  border-radius: 8px;
  background-color: var(--color-primary);
  box-shadow: 0 5px 14px rgba(59, 130, 246, .18);
  color: var(--color-surface);
  font-size: var(--font-size-13);
  font-weight: 750;
  align-items: center;
  justify-content: center;

  &:hover {
    background: var(--color-primary-strong);
  }

  &:disabled {
    border-color: #d9dee4;
    background: #f3f4f6;
    box-shadow: none;
    color: #a1a8b0;
    cursor: not-allowed;
  }
`

const SearchModalActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 18px;
`;

const CancelSearchButton = styled.button`
  width: 96px;
  height: 42px;
  border: 1px solid #d8dee5;
  border-radius: 8px;
  background: var(--color-surface);
  color: #65717d;
  font-size: var(--font-size-13);
  font-weight: 700;

  &:hover {
    background: #f7f9fb;
  }
`;

const SelectionRadio = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid ${({$selected}) => ($selected ? "var(--color-primary)" : "#cbd2da")};
  border-radius: 50%;
  background: ${({$selected}) => ($selected ? "var(--color-primary)" : "var(--color-surface)")};
  box-shadow: ${({$selected}) => ($selected ? "inset 0 0 0 4px var(--color-surface)" : "none")};
`;


const MediaSearchResult = styled.div`
  position: relative;
  padding: 0 18px 18px 96px;
  border: 0;
  border-radius: 0;
  background: #f7f9fc;
  font-size: var(--font-size-12);

  &::before {
    position: absolute;
    top: 28px;
    left: 18px;
    color: #3e4955;
    content: "검색 결과";
    font-size: var(--font-size-13);
    font-weight: 750;
  }
  
  .table-scroll {
    max-height: 320px;
    margin-top: 14px;
    overflow-y: auto;
    border: 1px solid #e5eaf0;
    border-radius: 9px;
  }
  
  & table {
    width: 100%;
    border-collapse: collapse;
    background: var(--color-surface);

    tbody,
    tbody tr,
    tbody td {
      background: var(--color-surface);
    }

    & th {
      position: sticky;
      top: 0;
      z-index: 1;
      height: 40px;
      padding: 0 12px;
      border-bottom: 1px solid var(--color-border-strong);
      background-color: #f7f9fc;
      color: #64707d;
      font-size: var(--font-size-11);
      font-weight: 750;

      &:first-child {
        width: 44px;
      }
    }

    & td {
      text-align: center;
      height: 42px;
      padding: 0 12px;
      border-bottom: 1px solid #edf1f4;
      color: #4b5662;
      cursor: pointer;
    }

    tbody tr {
      transition: background .15s ease;
    }

    tbody tr:hover {
      background: #f0f7ff;

      td {
        background: #f0f7ff;
      }
    }

    tbody tr.is-selected {
      background: var(--color-primary-soft);

      td {
        background: var(--color-primary-soft);
        color: var(--color-primary-dark);
        font-weight: 700;
      }
    }

    tbody tr:last-child td {
      border-bottom: 0;
    }
  }
`

const InputGroup = styled.div`
  display: flex;
  gap: 8px;

  & input[type='text'] {
    width: 100%;
    height: 42px;
    padding: 0 13px;
    border: 1px solid var(--color-border-strong);
    border-radius: 8px;
    color: var(--color-text);
    font-size: var(--font-size-13);
    outline: none;
  }

  & input:hover,
  & input:focus {
    border: 1px solid #60a5fa;
  }

  & input:focus {
    box-shadow: 0 0 0 3px rgba(59, 130, 246, .10);
  }

  & button {
    min-width: 76px;
    height: 42px;
    border: 1px solid var(--color-primary);
    border-radius: 8px;
    background-color: var(--color-primary);
    color: var(--color-surface);
    font-size: var(--font-size-12);
    font-weight: 700;

    &:hover {
      background: var(--color-primary-strong);
    }
  }
`

const Button = styled.button`
  width: 150px;
  height: 45px;
  border-radius: 5px;
  background-color: #777777;
  color: var(--color-surface);
  font-size: var(--font-size-17);
  cursor: pointer;

  &:hover {
    background-color: #535353;
  }
`

const SwitchUserButton = styled.button`
  background-color: var(--color-surface);
  padding: 13px 40px;
  border: 1px solid #ddd;
  border-radius: 5px;
`

const HistoryAdd = styled.div`
  > p {
    margin: 20px 0 10px;
  }
  .border-box {
    padding: 15px 20px;
    border: solid 1px #e5e5e5;
    span {
      width: 100px; 
      color: #777;
    }
    .inputCon {
      width: 70%;
      display: flex;
      align-items: center;
    }
    textarea {
      width: 100%;
      background-color: transparent;
      margin: 0;
      padding: 10px;
      border-radius: 10px;
      border: solid 1px #e5e5e5;
    }
    .won {
      width: calc(100% - 78px);
      height: 45px;
      display: flex;
      align-items: center;
      padding: 8px 15px;
      border-radius: 10px;
      border: solid 1px #e5e5e5;
      input {
        width: 100%;
        border: 0;
        background-color: transparent;
        text-align: right;
        font-size: var(--font-size-20);
        &::placeholder {
          font-size: var(--font-size-15);
        }
      }
    }
  }
`
const Validation = styled.div`
  min-height: 100px;
  margin-top: 14px;
  padding: 40px 16px;
  border: 1px dashed var(--color-border-strong);
  border-radius: 9px;
  background: #fafbfc;
  text-align: center;
  color: var(--color-text-muted);
  font-size: var(--font-size-12) !important;
`
